// ABOUTME: Tooltip body for a localized text: the translation plus the author's original.
// ABOUTME: Card icons have no room for a toggle, so the tooltip carries both (WA-762).

import { useTranslation } from "react-i18next"
import type { L10nFragment } from "@/graphql/main/gql/graphql"
import { resolveL10n } from "./fn"

interface IProps {
  value: L10nFragment | null | undefined
  /** Plain original field — rendered when the L10n sibling is absent. */
  fallback?: string | null
}

export const L10nTooltipText = ({ value, fallback }: IProps) => {
  const { t } = useTranslation()
  const view = resolveL10n(value, fallback)

  return (
    <span className="block max-w-xs whitespace-pre-wrap wrap-anywhere">
      {view.display}
      {view.canShowOriginal && (
        <span className="mt-2 block border-t border-current/25 pt-1.5 opacity-70">
          <span className="block text-[11px] uppercase tracking-wide">{t("l10n.translated")}</span>
          <span className="block">{view.original}</span>
        </span>
      )}
      {view.badge === "locked" && (
        <span className="mt-2 block border-t border-current/25 pt-1.5 text-[11px] opacity-70">
          {t("l10n.lockedHint")}
        </span>
      )}
      {view.badge === "pending" && (
        <span className="mt-2 block border-t border-current/25 pt-1.5 text-[11px] opacity-70">
          {t("l10n.translating")}
        </span>
      )}
    </span>
  )
}

export default L10nTooltipText
